import {createAction} from 'redux-actions';
import {getContentTypesList} from '@pluto/rest';

export const CONTENT_TYPES_SET = 'CONTENT_TYPES_SET';

export const setContentTypesAction = createAction(CONTENT_TYPES_SET, async () => {
    return await getContentTypesList();
});
